// extracted by mini-css-extract-plugin
module.exports =  {"body":"K3RUnRtkPnbGvRwZSFSg","sizeXl":"bXR_CmI4FrCydIYjYIfc"};